import { render, staticRenderFns } from "./ListProveedor.vue?vue&type=template&id=d9545442&"
import script from "./ListProveedor.vue?vue&type=script&lang=js&"
export * from "./ListProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports